import { OrderState } from '@models/ropolo';
import { CreateOrderItem, OfflineOrderingState } from '../types';

const addItemToOrder = (menus: CreateOrderItem[], tempId: string): CreateOrderItem[] =>
  menus.map((item) => {
    if (item.tempId === tempId) {
      return {
        ...item,
        count: (item.count || 0) + 1,
        orderItemToppings: item?.orderItemToppings?.map((x) => ({
          ...x,
          count: (item.count || 0) + 1,
        })),
      };
    }
    return item;
  });

const EditedOrder = (state: OfflineOrderingState, tempId: string): OfflineOrderingState => {
  const canAdd = state?.order && state?.order?.orderHistoryState === OrderState.SUBMITTED;
  const updatedMenuItem = state?.menus?.find((x) => x.tempId === tempId);
  const orderMenuItem = state?.order?.orderItems?.find((x) => x.id === tempId);

  if (updatedMenuItem) {
    if (updatedMenuItem?.count && updatedMenuItem?.count > 0) {
      return {
        ...state,
        menus: state?.menus?.map((item) => {
          let count = 0;
          if (!canAdd) {
            count = (item.count || 0) + 1 > (orderMenuItem?.count || 0) ? item.count || 0 : (item.count || 0) + 1;
          } else {
            count = (item.count || 0) + 1;
          }
          if (item.tempId === tempId) {
            return {
              ...item,
              count,
              orderItemToppings: item?.orderItemToppings?.map((x) => ({
                ...x,
                count,
              })),
              toppings: item?.orderItemToppings?.map((x) => ({
                ...x,
                count,
              })),
            };
          }
          return item;
        }),
      };
    }
  }

  return { ...state };
};

const addMenuItemByTempId = (state: OfflineOrderingState, tempId: string): OfflineOrderingState => {
  if (state.isEdited) {
    return EditedOrder(state, tempId);
  }
  return {
    ...state,
    menus: addItemToOrder(state?.menus, tempId),
  };
};

export default addMenuItemByTempId;
